import React from 'react'

const IconLearnMode = ({ width = '24', height = '24' }) => (
  <svg
    viewBox={`0 0 ${width} ${height}`}
    width={`${width}px`}
    height={`${height}px`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6.49779V17.149C15.3114 15.9133 17.4796 15.9024 19 16.0843V5.13518C17.3967 4.89167 15.3725 4.79049 13 6.49779ZM21 4.00002L20.9999 3.39997C20.8538 3.39998 20.6146 3.35463 20.2972 3.29443C18.7726 3.00537 15.4436 2.37417 11.9638 4.78307C9.8413 3.48126 7.84524 3.10705 6.23421 3.08013C5.35921 3.0655 4.60719 3.15332 4.02825 3.24127C3.84181 3.26959 3.65941 3.30027 3.50682 3.32593C3.43246 3.33844 3.36518 3.34975 3.30797 3.35902C3.21317 3.37439 3.14011 3.38525 3.08227 3.39222C3.02672 3.39892 3.003 3.39976 3.00028 3.39986C3.00016 3.39986 3.00002 3.39987 3.00028 3.39986L3.00003 4.00002L2.99996 5.00002H0V21H24V5.00002H21.0001L21 4.00002ZM21 7.00002L21.0001 18.4C20.5875 18.4 20.1197 18.3209 19.5997 18.233C18.0769 17.9756 16.1068 17.6425 13.7664 19H22V7.00002H21ZM11 17.2489V6.53868C9.19259 5.40815 7.52761 5.10203 6.20079 5.07985C5.76598 5.07258 5.36404 5.09581 5 5.13261V16.124C5.37512 16.0918 5.78872 16.0727 6.23421 16.0801C7.59892 16.1029 9.23991 16.3749 11 17.2489ZM2.99993 18.3999C3.20601 18.3999 3.44229 18.3633 3.62789 18.3333C3.70764 18.3203 3.78572 18.3072 3.86567 18.2937C4.00751 18.2698 4.15523 18.2449 4.32862 18.2186C4.84656 18.1399 5.47829 18.0678 6.20079 18.0798C7.2861 18.098 8.59767 18.3061 10.0284 19H2V7.00002H3L2.99993 18.3999Z"
    />
  </svg>
)

export default IconLearnMode
